import { render, staticRenderFns } from "./OsPaleteira.vue?vue&type=template&id=707f38d6&"
import script from "./OsPaleteira.vue?vue&type=script&lang=js&"
export * from "./OsPaleteira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports